import { useState, useCallback } from "react";

const useCopyToClipboards = (timeout = 2000) => {
  const [copiedKey, setCopiedKey] = useState<string | null>(null);

  const copyToClipboard = useCallback(
    async (text: string, key: string) => {
      try {
        await navigator.clipboard.writeText(text);
        setCopiedKey(key);
        setTimeout(() => setCopiedKey(null), timeout);
      } catch (err) {
        console.error("Failed to copy to clipboard:", err);
      }
    },
    [timeout],
  );

  const isCopiedClip = (key: string) => copiedKey === key;

  return { copyToClipboard, isCopiedClip };
};

export default useCopyToClipboards;
